import { Cloud } from '@reolink-deps/reolink-web_multisite-utils';

const configAllREG = /\[cloud(?:=(.*?))?\](.*?)\[\/cloud\]/g;

/**
 * 
 * 处理被cloud标签包裹的内容，当所在的国家支持云服务时返回cloud标签所包裹的值,否则返回空
 * @param text
 * @returns
 */
function handelCloudText(text: string): string {
    if (typeof text !== 'string') {
        return text;
    }
    const res = text.replace(configAllREG, (matchedTag, typeStr, value) => {
        try {
            if (!typeStr) {
                typeStr = 'all';
            }
            else {
                typeStr = typeStr.toLowerCase();
            }
            if (Cloud.isSupport(typeStr as Cloud.TSupportType)) {
                return value;
            }
        }
        catch (e) {
            const errorMessages: string[] = ['Replace cloud text error'];
            errorMessages.push(`matchedTag: ${matchedTag}`);
            errorMessages.push(`typeStr: ${typeStr}`);
            console.error(errorMessages.join(', '), e);
        }
        return '';
    });
    return res;
}

export default handelCloudText;
